import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7248940f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-container tabs-content"
}
const _hoisted_2 = {
  key: 1,
  class: "table-container tabs-content"
}

import { MonetaryValueWithCommas } from "@/services/helpers/Helper";
import {
    cols,
    labels,
    tabVATReturns,
    tabs,
    currentTab,
    displayedVATReturns,
    Box1VATs,
    Box3VATs,
    Box4VATs,
    Box5VATs,
    Box6VATs,
    Box7VATs,
    box1AmountVATTotal,
    box3AmountVATTotal,
    box4AmountVATTotal,
    box5AmountVATTotal,
    box6AmountExVATTotal,
    box7AmountExVATTotal,
    box1JournalingTypes,
    box3JournalingTypes,
    box4JournalingTypes,
    box5JournalingTypes,
    box6JournalingTypes,
    box7JournalingTypes,
} from "@/services/helpers/VATReturns/VATReturnsVariables";
import {
    GetAmountTotal,
    GetTabVATReturns,
    ToggleTab,
    GetClassOrSignBackoutCompatible,
} from "@/services/helpers/VATReturns/VATReturnsFunctions";
// Data
import JournalVAT from "@/models/VATReturns/JournalVat";
// Table
import Table from "@/components/TablePersistentChecking.vue";
// Misc
import log from "loglevel";
import { ref } from "vue";
import { JournalingOptions } from "@/models/Journaling/JournalingTypes";
import { DisplayableKeys } from "@/services/SorterService";


export default /*#__PURE__*/_defineComponent({
  __name: 'VATReturnsTables',
  setup(__props) {

// Services
const rowCount = ref(100);

log.trace("displayedVATReturns.value:", displayedVATReturns.value);
Box1VATs.value = GetTabVATReturns(tabs.Box1);
log.trace("Box1VATs:", Box1VATs.value);
box1AmountVATTotal.value = GetAmountTotal(Box1VATs.value, tabs.Box1);
log.trace("box1AmountVATTotal:", box1AmountVATTotal.value);
box1JournalingTypes.value = [...new Set(Box1VATs.value.map((vat: JournalVAT) => vat.JournalingType ?? "") || [])];


Box3VATs.value = GetTabVATReturns(tabs.Box1, tabs.Box2);
log.trace("Box3VATs:", Box3VATs.value);
box3AmountVATTotal.value = GetAmountTotal(Box3VATs.value, tabs.Box1, tabs.Box2);
log.trace("box3AmountVATTotal:", box3AmountVATTotal.value);
box3JournalingTypes.value = [...new Set(Box3VATs.value.map((vat: JournalVAT) => vat.JournalingType ?? "") || [])];


Box4VATs.value = GetTabVATReturns(tabs.Box4);
log.trace("Box4VATs:", Box4VATs.value);
box4AmountVATTotal.value = GetAmountTotal(Box4VATs.value, tabs.Box4);
log.trace("box4AmountVATTotal:", box4AmountVATTotal.value);
box4JournalingTypes.value = [...new Set(Box4VATs.value.map((vat: JournalVAT) => vat.JournalingType ?? "") || [])];


const Tab5Box3VATs: JournalVAT[] = GetTabVATReturns(tabs.Box1, tabs.Box2);
const Tab5Box4VATs: JournalVAT[] = GetTabVATReturns(tabs.Box4);
Box5VATs.value = [...Tab5Box3VATs, ...Tab5Box4VATs]
log.trace("Box5VATs:", Box5VATs.value);
box5AmountVATTotal.value = 0;
box5AmountVATTotal.value += GetAmountTotal(Tab5Box3VATs, tabs.Box1, tabs.Box2);
box5AmountVATTotal.value -= GetAmountTotal(Tab5Box4VATs, tabs.Box4);
log.trace("box5AmountVATTotal:", box5AmountVATTotal.value);
box5JournalingTypes.value = [...new Set(Box5VATs.value.map((vat: JournalVAT) => vat.JournalingType ?? "") || [])];


Box6VATs.value = GetTabVATReturns(tabs.Box6);
log.trace("Box6VATs:", Box6VATs.value);
box6AmountExVATTotal.value = GetAmountTotal(Box6VATs.value, tabs.Box6);
log.trace("box6AmountExVATTotal:", box6AmountExVATTotal.value);
box6JournalingTypes.value = [...new Set(Box6VATs.value.map((vat: JournalVAT) => vat.JournalingType ?? "") || [])];


Box7VATs.value = GetTabVATReturns(tabs.Box7);
log.trace("Box7VATs:", Box7VATs.value);
box7AmountExVATTotal.value = GetAmountTotal(Box7VATs.value, tabs.Box7);
log.trace("box7AmountExVATTotal:", box7AmountExVATTotal.value);
box7JournalingTypes.value = [...new Set(Box7VATs.value.map((vat: JournalVAT) => vat.JournalingType ?? "") || [])];


class VATReturnsSummary {
    Box?: tabs;
    BoxString?: string;
    Description?: string;
    Total?: string;

    constructor(data: Partial<VATReturnsSummary>) {
        Object.assign(this, data);
    }
}

const VATReturnsSummaryRows: VATReturnsSummary[] = (
    displayedVATReturns.value?.length
        ? [
            new VATReturnsSummary({ Box: tabs.Box1, BoxString: `Box ${tabs.Box1}`, Description: "Sales VAT", Total: MonetaryValueWithCommas(box1AmountVATTotal.value) }),
            new VATReturnsSummary({ Box: tabs.Box3, BoxString: `Box ${tabs.Box3}`, Description: "Total VAT Due", Total: MonetaryValueWithCommas(box3AmountVATTotal.value) }),
            new VATReturnsSummary({ Box: tabs.Box4, BoxString: `Box ${tabs.Box4}`, Description: "Reclaimed VAT", Total: MonetaryValueWithCommas(box4AmountVATTotal.value) }),
            new VATReturnsSummary({ Box: tabs.Box5, BoxString: `Box ${tabs.Box5}`, Description: "Paid or Reclaimed VAT", Total: MonetaryValueWithCommas(box5AmountVATTotal.value) }),
            new VATReturnsSummary({ Box: tabs.Box6, BoxString: `Box ${tabs.Box6}`, Description: "Sales Net Value", Total: MonetaryValueWithCommas(box6AmountExVATTotal.value) }),
            new VATReturnsSummary({ Box: tabs.Box7, BoxString: `Box ${tabs.Box7}`, Description: "Purchases Net Value", Total: MonetaryValueWithCommas(box7AmountExVATTotal.value) }),
        ]
        : []
);
const VATReturnsSummaryCols: DisplayableKeys<VATReturnsSummary>[] = ["BoxString", "Description", "Total"];
const VATReturnsSummaryLabels: string[] = ["Box", "Description", "Total"];

function RowClicked(row: any) {
    log.trace(`RowClicked()\nrow: ${JSON.stringify(row)}`);
    log.trace(`RowClicked()\nrowBox: ${row.value.Box}`);

    ToggleTab(row.value.Box);
}

return (_ctx: any,_cache: any) => {
  return (_unref(currentTab) != _unref(tabs).Summary)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Table, {
          Rows: _unref(tabVATReturns),
          Cols: _unref(cols),
          Labels: _unref(labels),
          RowsPerPage: rowCount.value,
          "onUpdate:RowsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((rowCount).value = $event)),
          PageOptions: [100, 200, 500, 1000, 2000, 5000]
        }, {
          IssueDateTime: _withCtx((props) => [
            _createElementVNode("div", null, _toDisplayString(props.value.IssueDateTime.toLocaleString("sv-SE")
                            .split(" ")[0]
                            .replaceAll("-", "/")), 1)
          ]),
          AmountExVat: _withCtx((props) => [
            _createElementVNode("div", {
              class: _normalizeClass(_unref(GetClassOrSignBackoutCompatible)(props.value, undefined, true, false))
            }, _toDisplayString(props.value.Reference.startsWith(_unref(JournalingOptions).JournalBackoutPrefix)
                        ? _unref(GetClassOrSignBackoutCompatible)(props.value, -props.value.AmountExVat, false, false)
                        : _unref(GetClassOrSignBackoutCompatible)(props.value, props.value.AmountExVat, false, false)), 3)
          ]),
          AmountVat: _withCtx((props) => [
            _createElementVNode("div", {
              class: _normalizeClass(_unref(GetClassOrSignBackoutCompatible)(props.value, undefined, true))
            }, _toDisplayString(props.value.Reference.startsWith(_unref(JournalingOptions).JournalBackoutPrefix)
                        ? _unref(GetClassOrSignBackoutCompatible)(props.value, -props.value.AmountVat, false)
                        : _unref(GetClassOrSignBackoutCompatible)(props.value, props.value.AmountVat, false)), 3)
          ]),
          AmountTotal: _withCtx((props) => [
            _createTextVNode(_toDisplayString(props.value.Reference.startsWith(_unref(JournalingOptions).JournalBackoutPrefix)
                    ? _unref(MonetaryValueWithCommas)(-props.value.AmountTotal)
                    : _unref(MonetaryValueWithCommas)(props.value.AmountTotal)), 1)
          ]),
          _: 1
        }, 8, ["Rows", "Cols", "Labels", "RowsPerPage"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(Table, {
          Rows: _unref(VATReturnsSummaryRows),
          Cols: VATReturnsSummaryCols,
          Labels: VATReturnsSummaryLabels,
          RowClicked: RowClicked
        }, {
          Total: _withCtx((props) => [
            _createTextVNode(_toDisplayString(props.value.Total == "-0.00" ? props.value.Total.slice(1) : props.value.Total), 1)
          ]),
          _: 1
        }, 8, ["Rows"])
      ]))
}
}

})